import React from 'react';
import Table from '../../components/common/Table';
import { NewsletterDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';
import { renderBooleanBadge } from '../../utils/displayUtils';

interface NewsletterTableProps {
  data: NewsletterDTO[];
  handleEdit: (row: NewsletterDTO) => void;
  handleDelete: (row: NewsletterDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const NewsletterTable: React.FC<NewsletterTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Title',
          key: 'title',
        },
        {
          label: 'Category',
          key: 'newsletterCategory',
          render: (row: NewsletterDTO) => (
              row.newsletterCategory ? <span>{row.newsletterCategory?.title}</span> : <span>None</span>
          )
        },
        {
          label: 'Date',
          key: 'date',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
        {
          label: 'Volume',
          key: 'volume',
        },
        {
          label: 'Active',
          key: 'isActive',
          render: (row: NewsletterDTO) =>
            renderBooleanBadge(row.isActive ?? false),
        },
        {
          label: 'Added',
          key: 'createdUtc',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default NewsletterTable;
